
  import { Prop, Component, Vue } from 'vue-property-decorator'
  import { OrderModel } from '@/models'

  @Component
  export default class Invoice extends Vue {
    @Prop() readonly order!: OrderModel;
  }
